import Marquee from "react-fast-marquee";

const words = ["Bouncy Houses", "Party Tents", "Tables & Chairs", "Water Slides", "Popcorn Carts", "Weddings", "Birthdays", "Backyard Bashes"];

export default function TextMarquee() {
  return (
    <div className="border-y-2 border-ink bg-brand-yellow py-4 md:py-6 overflow-hidden" data-testid="marquee">
      <Marquee speed={45} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="mx-6 inline-flex items-center gap-6 font-display font-800 text-2xl md:text-4xl uppercase tracking-tight text-ink">
            {w}
            <span className="text-brand-coral">✳</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
